import { LicenceDocument } from "./LicenceDocument";

export class LicenceSave {
    public licenceMasterId: number = 0;
    public licenceName: string = "";
    public licenceNumber: string = "";
    public licenceCountry: string = "";
    public licenceAuthority: string = "";
    public licenceOn: string = "";
    public documents: LicenceDocument[] = [];
}